import * as React from 'react';
import {useState} from "react";
import "./TabsPanel.sass"
import PinDropIcon from '@mui/icons-material/PinDrop';
import PhoneIcon from '@mui/icons-material/Phone';
import InstagramIcon from '@mui/icons-material/Instagram';
import {ADDRESS} from "../_api/client";

export const Tab = (props) => {
    const {label, value, index, onClick} = props;

    return (
        <div className={"Tab" + (value === index ? " Tab-active" : "")}
             onClick={() => onClick(index)}>
            {label}
        </div>
    )
}

export const TabPanel = (props) => {
    const {value, index, children} = props;

    return (
        <div className="TabPanel" hidden={value !== index}>
            {children}
        </div>
    )
}

export function TabsPanel() {
    const tikTokIcon = `${ADDRESS}/images/about/tiktok-icon.svg`
    const [value, setValue] = useState(0);

    const handleChange = (newValue) => {
        setValue(newValue)
    }

    const renderMogilev = () => {
        return (<>
            <div className="AboutPage-item">
                <div>
                    <PinDropIcon/>
                </div>
                <div>ул. Первомайская 20 Б</div>
            </div>
            <div className="AboutPage-item">
                <div>
                    <PhoneIcon/>
                </div>
                <div>
                    <div>
                        <a style={{color: 'white', textDecoration: 'none'}}
                           href="tel:+375 (29) 248-04-62">+375 (29) 248-04-62</a>
                    </div>
                    <div>
                        <a style={{color: 'white', textDecoration: 'none'}}
                           href="tel:+375 (29) 642-04-62">+375 (29) 642-04-62</a>
                    </div>
                </div>
            </div>
            <div className="AboutPage-item">
                <div>
                    <InstagramIcon/>
                </div>
                <div>
                    <a style={{color: 'white', textDecoration: 'none'}}
                       target="_blank"
                       href="https://www.instagram.com/smart_olympic_school/">smart_olympic_school</a>
                </div>
            </div>
        </>)
    }

    const renderZhlobin = () => {
        return (<>
            <div className="AboutPage-item">
                <div>
                    <PinDropIcon/>
                </div>
                <div>-</div>
            </div>
            <div className="AboutPage-item">
                <div>
                    <PhoneIcon/>
                </div>
                <div>
                    -
                </div>
            </div>
            <div className="AboutPage-item">
                <div>
                    <InstagramIcon/>
                </div>
                <div>
                    -
                </div>
            </div>
            <div className="AboutPage-item">
                <div>
                    <img src={tikTokIcon} alt="qi_centr_razvitie"/>
                </div>
                <div>
                    -
                </div>
            </div>
        </>)
    }

    return (
        <div className="tabs-panel-wrapper">
            <TabPanel value={value} index={0}>
                {renderZhlobin()}
            </TabPanel>
            <TabPanel value={value} index={1}>
                {renderMogilev()}
            </TabPanel>
            <div className="tab-wrapper">
                <Tab value={value}
                     index={0}
                     onClick={handleChange}
                     label="Жлобин"/>
                <Tab value={value}
                     index={1}
                     onClick={handleChange}
                     label="Могилёв"/>
            </div>
        </div>
    );
}